// src/pages/TermsOfService.js
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Settings, X } from "lucide-react"

const TermsOfService = () => {
  return (
    <div className="container mx-auto max-w-l mt-6 p-4">
      <Link to="/" className="inline-flex items-center text-gray-600 mb-4">
        <ArrowLeft className="w-5 h-5 mr-1" />
        BACK
      </Link>
      <h1 className="text-2xl font-bold mt-4">Terms and Conditions</h1>
      <p className="mt-4">
        1. Introduction<br />
        By using HereFit you confirm your acceptance of, and agree to be bound by, these terms and conditions.
      </p>
      {/* Thêm các đoạn văn bản khác từ file termsofservice.png */}
    </div>
  );
};

export default TermsOfService;